import { Component } from '@angular/core';
import { BlogService } from '../../home/services/blog/blog.service';
import { Blog } from 'src/app/model/blog';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-blogs',
  templateUrl: './blogs.component.html',
  styleUrls: ['./blogs.component.css'],
})
export class BlogsComponent {
  blog: any[] = [];
  lang = (localStorage.getItem('lang') || 'en').toUpperCase();
  isArabic: boolean = false;
  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 3,
      numScroll: 1,
    },
    {
      breakpoint: '992px',
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: '768px',
      numVisible: 1,
      numScroll: 1,
    },
  ];

  constructor(
    private readonly blogService: BlogService,
    private readonly router: Router
  ) {}

  ngOnInit() {
    this.isArabic = this.lang === 'AR';
    this.blogService.getAllBlogs().subscribe((res: Blog[]) => {
      this.blog = res
        .filter((blog) => blog.language === 'EN')
        .map((blog) => {
          const formattedDate = new Date(
            blog.creationDate
          ).toLocaleDateString();
          return {
            id: blog.blogId,
            category: blog.category,
            title: blog.title,
            by:
              blog.author.role === 'ADMIN'
                ? `admin / ${formattedDate}`
                : `${blog.author.name} / ${formattedDate}`,
            img: environment.apiImagePath + blog.imageUrl,
          };
        });
    });
  }

  viewBlog(id: string) {
    this.router.navigate(['/blogs', id]);
  }
}
